import { useLayoutEffect, useRef } from "react";

const useLatest = (value: any) => {
    const valueRef = useRef(undefined);

    useLayoutEffect(() => {
        valueRef.current = value;
    });

    return valueRef;
};

export default useLatest;
